import MUICheckbox, { CheckboxProps as MUICheckboxProps } from '@material-ui/core/Checkbox';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import React from 'react';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';

export interface CheckboxProps extends MUICheckboxProps {
  checkedColor?: string;
}

export function Checkbox({ checkedColor = theme.colors.primary, ...props }: CheckboxProps) {
  return (
    <MUICheckbox
      icon={<CheckBoxOutlineBlankIcon color="secondary" fontSize="medium" />}
      checkedIcon={<CheckedIcon fontSize="medium" $color={checkedColor} />}
      {...props}
    />
  );
}

const CheckedIcon = styled(CheckBoxIcon)<{ $color: string }>`
  color: ${(props) => props.$color};
`;
